import * as React from 'react';
import { Trans } from 'react-i18next';
import s from '../Cycles/Cycles.scss';
import { Text } from '@wix/design-system';

export interface DiscalimerHeadingProps {
  isEligibleForRevShare: boolean;
}

export const DiscalimerHeading: React.FC<DiscalimerHeadingProps> = ({
  isEligibleForRevShare,
}: {
  isEligibleForRevShare: boolean;
}) => {
  return (
    <Text
      tagName='div'
      weight='normal'
      size='small'
      dataHook='monthly-disclaimer-header'
      className={s.monthlyDisclaimerHeading}
    >
      {isEligibleForRevShare ? (
        <Trans
          i18nKey='cycle_entry.monthly_disclaimer_revshare.note'
          components={{
            strong: <Text size='small' weight='bold'></Text>,
          }}
        />
      ) : (
        <Trans i18nKey='cycle_entry.monthly_disclaimer.note'>
          <strong>cycle_entry</strong>.monthly_disclaimer.note
        </Trans>
      )}
    </Text>
  );
};
